import { useState } from 'react';
import { toast } from 'sonner';
import { submitGdpr } from '@/lib/api';

const DataRequestPage = () => {
  const [email, setEmail] = useState('');
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await submitGdpr(email, reason);
      toast.success('Request received. We will action within 30 days.');
      setEmail(''); setReason('');
    } catch { toast.error('Could not submit request'); }
    finally { setLoading(false); }
  };

  return (
    <div className="container-pd py-16 max-w-2xl" data-testid="data-request-page">
      <h1 className="font-display text-5xl leading-none">Data deletion request</h1>
      <p className="mt-4 text-muted-sage">Submit your email and reason and we'll action your request within 30 days as required by UK GDPR.</p>
      <form onSubmit={submit} className="mt-8 space-y-4">
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@example.com"
          className="w-full h-12 rounded-xl bg-surface border border-pd px-4 text-sm focus:border-[color:var(--pd-accent-yellow)]"
          data-testid="data-request-email"
        />
        <textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          rows={4}
          placeholder="Reason (optional)"
          className="w-full rounded-xl bg-surface border border-pd px-4 py-3 text-sm focus:border-[color:var(--pd-accent-yellow)]"
          data-testid="data-request-reason"
        />
        <button disabled={loading} className="bg-[color:var(--pd-accent-yellow)] text-[#14251c] rounded-xl px-4 py-3 font-medium disabled:opacity-60" data-testid="data-request-submit">
          {loading ? 'Submitting…' : 'Submit request'}
        </button>
      </form>
    </div>
  );
};

export default DataRequestPage;
